import React, { Component, Fragment } from 'react'
import styled, { css } from 'styled-components'
import Input, { Input0Input } from '../../../../components/Input'
import Icon from '../../../../components/Icon'
import { createForm, formShape } from 'rc-form'
import Button from '../../../../components/Button'
import Select from '../../../../components/Select'
import CheckBox from '../../../../components/CheckBox'
import translate from '../../../../modules/translate'
import Title from '../../../../components/Title'
import Text from '../../../../components/Text'
import CircularProgress from '../../../../components/CircularProgress'
import { AxiosProvider, Post, Put } from 'react-axios'
import axios from 'axios'
import IconError from '../../../Error/components/IconError/'
import { setStoredItem, getStoredItem, clearStoredItem } from '../../../../modules/stored-item'
import Config from '../../../../config'
import Login from '../Login'
import InputDropZone from '../../../../components/InputDropZone'
import { generatePathByRouteName, namedRoute } from '../../../../modules/named-router'
import southTyrolCommunities from '../../../../config/data/southTyrolCommunities'
import { withRouter } from 'react-router'
import errorLog from '../../../../modules/error-log'
import PasswordEye from './components/PasswordEye'
import isServerSide from '../../../../modules/is-server-side'

const displosable_email_blocklist = require('../../../../config/blacklist/disposable_email_blocklist.json')

const StyledInputDropZoneWrapper = styled.div`
  margin-bottom: 0.5em;
`

const StyledInputDropZone = styled(InputDropZone)``

let placeOfResidenceOptions = []
let zipOptions = []
let genderOptions = [
  {
    value: 'man',
    label: translate('login_select_man'),
  },
  {
    value: 'woman',
    label: translate('login_select_woman'),
  },
]

southTyrolCommunities.all.map((community) => {
  placeOfResidenceOptions.push({ value: community.name, label: community.name })
  zipOptions.push({ value: community.name, label: community.plz })
  return null
})

const LoginWrapper = styled.div`
  background-color: ${(props) => props.theme.color.background};
  box-shadow: 0px 1px 3px;
  padding: 1em;
  min-height: 20em;
  text-align: center;
  z-index: 1;
`

const StyledInput = styled(Input)`
  position: relative;
  margin-bottom: 1em;
  ${(props) =>
    props.placeholder === 'fakePassword' &&
    css`
      margin-bottom: 0;
      border: 0;
      position: absolute;
      top: -100vh;
      height: 0;
      width: 0;
    `}
  ${(props) =>
    props.type === 'password' &&
    css`
      text-security: disc;
      -webkit-text-security: disc;
      -mox-text-security: disc;
    `}
  ${Input0Input} {
    ${(props) =>
      props.prepend
        ? css`
            padding-left: 2.5em;
          `
        : css`
            padding-left: 0.5em;
          `}
    padding-right: 2em;
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.mobile.fontSize.title3};
  }
`

const StyledPrependIcon = styled(Icon)`
  position: absolute;
  left: 1em;
  color: ${(props) => props.theme.color.textTertiary};
  top: 10px;
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`

const StyledButton = styled(Button)`
  margin-top: 0.5em;
  margin-bottom: 0.5em;
`

const StyledCheckBox = styled(CheckBox)`
  .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${(props) => props.theme.color.stol};
  }
`

const StyledTitle = styled(Title)`
  font-size: ${(props) => props.theme.fontSize.title2};
  margin-bottom: 1em;
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.tablet.fontSize.title2};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.mobile.fontSize.title2};
  }
`

const Help = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`

const StyledText = styled(Text)`
  cursor: pointer;
  margin-bottom: 0.5em;
  margin-top: 0.5em;
  &:hover {
    color: ${(props) => props.theme.color.stol};
  }
`

const StyledConfirmationText = styled(Text)`
  color: green;
  margin-top: 1em;
  margin-bottom: 1em;
`

const StyledErrorText = styled(Text)`
  color: red;
  margin-top: 1em;
`

const LoginMessage = styled(Text)`
  margin: 0 auto;
  margin-bottom: 0px;
  margin-bottom: 1em;
  color: red;
  max-width: 18em;
`

const SelectIconError = styled(IconError)`
  float: right;
  margin-bottom: 0.5em;
  margin-top: 0.5em;
`

const SelectWrapper = styled.div`
  margin-bottom: 1em;
  text-align: left;
`

const CheckBoxWrapper = styled.div`
  display: flex;
`

const StyledCircularProgress = styled(CircularProgress)`
  margin-top: 0.5em;
  margin-bottom: 0.5em;
`

const StyledHelpButton = styled(Button)``

const LabelLink = styled.a`
  color: black;
  font-weight: bold;
  text-decoration: none;
`

const UserImage = styled.img`
  max-width: 250px;
  height: 160px;
  width: 160px;
`

const UserEditor = styled.div`
  margin-bottom: 1em;
  position: relative;
`

const UserImageWrapper = styled.div`
  position: relative;
  height: 160px;
  width: 160px;
  margin: 0 auto;
  margin-bottom: 1em;
`

const DeleteIcon = styled(Icon)`
  display: none;
  font-size: 60px;
  color: #fff;
  margin-right: 50px:
  margin-top: 50px:
`

const DeleteLayer = styled.div`
  position: absolute;
  &:hover {
    ${DeleteIcon} {
      display: block;
      margin-top: 50px;
      margin-left: 50px;
    }
    background-color: rgba(0, 0, 0, 0.3);
  }
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  transition: 1s ease;
  cursor: pointer;
  .deleteLayer {
    display: flex;
  }
`

let User = {}

class LoginForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      usernameFromLoginForm: '',
      passwordFromLoginForm: '',
      passwordIsVisible: false,
      request: '',
      loginMessage: this.props.loginMessage,
      deleteUserImage: false,
      screen: getStoredItem('user') !== null && getStoredItem('access_token', true) !== null ? 'account' : 'login',
      currentTitle:
        getStoredItem('user') === null ? (
          <StyledTitle tag="h4">{translate('login_title')}</StyledTitle>
        ) : (
          <StyledTitle tag="h4">{translate('login_change_my_data')}</StyledTitle>
        ),
    }
    this.submitPasswordForgottenRequest = this.submitPasswordForgottenRequest.bind(this)
    this.submitPasswordResetRequest = this.submitPasswordResetRequest.bind(this)
    this.submitLogin = this.submitLogin.bind(this)
    this.submitRegistration = this.submitRegistration.bind(this)
    this.submitRegistrationPartTwo = this.submitRegistrationPartTwo.bind(this)
    this.submitRegistrationPartTwoAlternative = this.submitRegistrationPartTwoAlternative.bind(this)
    this.callBackAfterLogin = this.callBackAfterLogin.bind(this)
    this.submitChangeDataRequest = this.submitChangeDataRequest.bind(this)
  }
  static propTypes = {
    form: formShape,
  }
  componentDidUpdate() {
    if (!isServerSide()) {
      window.setTimeout(() => {
        if (this.state.loginMessage !== undefined) {
          this.setState({
            loginMessage: undefined,
          })
        }
      }, 20000)
    }
  }
  componentDidMount() {
    if (this.props._match.path === generatePathByRouteName('register.verification', '')) {
      this.setState({
        screen: 'register.verification',
      })
    } else if (
      this.props._match.path === generatePathByRouteName('resetPassword', '') &&
      this.props._match.params.resetToken === undefined
    ) {
      this.setState({
        screen: 'resetPassword',
      })
    } else if (this.props._match.params.resetToken !== undefined) {
      this.setState({
        screen: 'resetPassword_2',
      })
    } else if (getStoredItem('access_token', true) === null && getStoredItem('user') !== null) {
      clearStoredItem('user')
      clearStoredItem('access_token', true)
      clearStoredItem('access_token_expires_in', true)
      clearStoredItem('refresh_token', true)
      this.props.callBackAfterLogout()
      this.setState({
        screen: 'login',
      })
    } else if (
      getStoredItem('access_token', true) !== null &&
      getStoredItem('user') === null &&
      namedRoute('account').path === this.props._match.path
    ) {
      if (!isServerSide()) {
        window.setTimeout(() => {
          this.forceUpdate()
        }, 500)
      }
    } else {
      this.setState({
        screen: 'login',
      })
    }
  }
  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false
    }
    return true
  }
  callBackAfterLogin() {
    this.props.callBackAfterLogin()
    this.setState({
      usernameFromLoginForm: '',
      passwordFromLoginForm: '',
      request: '',
      screen: 'account',
    })
  }
  submitChangeDataRequest() {
    let changedFields = this.props.form.getFieldsValue([
      'user.image',
      'user.gender',
      'user.firstName',
      'user.lastName',
      'user.placeOfResidence',
      'user.street',
      'user.placeZip',
      'user.telephone',
      'user.processingAdvertisementData',
    ])
    Object.keys(changedFields.user).forEach((key) => {
      if (changedFields.user[key] !== undefined) {
        if (key === 'processingAdvertisementData') {
          if (changedFields.user[key]) {
            User[key] = 1
          } else {
            User[key] = 0
          }
        } else if (key === 'gender') {
          User.gender = changedFields.user[key].value
        } else if (key === 'image') {
          User.image = changedFields.user[key][0].base64
        } else if (key === 'placeZip') {
          User.placeZip = changedFields.user[key]
        } else {
          User[key] = changedFields.user[key]
        }
      } else {
        if (key !== 'username') {
          User[key] = JSON.parse(getStoredItem('user'))[key]
        }
        if (key === 'placeZip') {
          User.placeZip = JSON.parse(getStoredItem('user')) && JSON.parse(getStoredItem('user')).placeZip
        } else {
          User.username = JSON.parse(getStoredItem('user')).email
        }
      }
    })
    if (this.state.request !== 'account') {
      if (User.image.length > 0 && !User.image.includes('base64') && this.state.deleteUserImage === false) {
        User.image = true
      }
      if (this.state.deleteUserImage) {
        delete User.image
      }
      this.setState({
        request: 'account',
      })
    }
  }
  submitPasswordForgottenRequest() {
    this.props.form.validateFields(['user.username'], {}, (error, value) => {
      if (value.user.username !== undefined && value.user.username.search('@') > 0) {
        if (error === null) {
          this.setState({
            usernameFromLoginForm: value.user.username,
            request: 'resetPassword',
          })
        } else {
          errorLog({ error: error, info: " can't submit submitPasswordForgottenRequest in LoginForm" })
        }
      }
    })
  }
  submitPasswordResetRequest() {
    if (this.props._match && this.props._match.params && this.props._match.params.resetToken) {
      this.props.form.validateFields(['user.username', 'user.password', 'user.passwordCheck'], {}, (error, value) => {
        if (error == null) {
          if (value.user.password === value.user.passwordCheck) {
            this.setState({
              request: 'resetPassword_2',
              passwordFromLoginForm: value.user.password,
              usernameFromLoginForm: value.user.username,
            })
          } else {
            this.setState({
              loginMessage: translate('login_password_check_error'),
            })
          }
        } else {
          errorLog({ error: error, info: 'resetPassword Form 2 failed' })
        }
      })
    } else {
      this.submitPasswordForgottenRequest()
    }
  }
  submitLogin() {
    this.props.form.validateFields(['user.username', 'user.password'], {}, (error, value) => {
      if (value.user.username !== undefined && value.user.password !== undefined) {
        if (error === null) {
          this.setState({
            usernameFromLoginForm: value.user.username,
            passwordFromLoginForm: value.user.password,
            request: 'login',
          })
        } else {
          errorLog({ error: error, info: " can't submit login in LoginForm" })
        }
      }
    })
  }
  // helper functions
  renameProp = (oldProp, newProp, { [oldProp]: old, ...others }) => ({
    [newProp]: old,
    ...others,
  })
  createMarkup(html) {
    return { __html: html }
  }
  getZipFromPreselectedCommunity(selected) {
    zipOptions.map((commune) => {
      if (commune.value === selected.value) {
        User.placeZip = commune
      }
      return null
    })
  }
  disposableChecker(email) {
    if (email !== undefined) {
      let returnValue = false
      displosable_email_blocklist.forEach((emailProvider) => {
        if (returnValue !== true) {
          returnValue = email.split('@')[1] === emailProvider ? true : false
        } else {
          return
        }
      })
      return returnValue
    } else {
      return false
    }
  }
  //
  submitRegistration() {
    this.props.form.validateFields(
      ['user.username', 'user.password', 'user.gender', 'user.firstName', 'user.lastName', 'user.image'],
      {},
      (error, value) => {
        if (error == null) {
          this.setState({
            screen: 'register.verification_2',
          })
          if (JSON.stringify(User) !== JSON.stringify(value.user)) {
            Object.keys(value.user).map((key) => {
              if (User[key] !== 'image' && value.user[key] !== undefined) {
                User[key] = value.user[key]
              }
              return null
            })
            if (User['username'] !== undefined) {
              if (this.disposableChecker(User['username'])) {
                delete User['username']
              } else {
                User.email = User['username']
                delete User['username']
              }
            }
            if (User['image'] === undefined) {
              delete User['image']
            } else {
              User['image'] = User['image'][0].base64
            }
            User['gender'] = User['gender'].value
          }
        } else {
          errorLog({ error: error, info: " can't submit Registration Form 1 in LoginForm" })
        }
      },
    )
  }
  registerUser() {
    //preparing data for registration
    User['processingAdvertisementData'] = User['processingAdvertisementData'] === false ? 0 : 1
    delete User['processingLoginData']
    delete User['agb']
    this.setState({
      request: 'register.verification',
    })
  }
  submitRegistrationPartTwo() {
    this.props.form.validateFields(
      [
        'user.placeOfResidence',
        'user.street',
        'user.placeZip',
        'user.telephone',
        'user.processingLoginData',
        'user.agb',
        'user.processingAdvertisementData',
      ],
      {},
      (error, value) => {
        if (error == null && value.user.processingLoginData === true && value.user.agb === true) {
          User = { ...User, ...value.user }
          User.placeOfResidence = User.placeOfResidence.value
          User.placeZip = User.placeZip.label
          this.registerUser()
        } else {
          errorLog({ error: error, info: " can't submit Registration Form 2 in LoginForm" })
        }
      },
    )
  }
  submitRegistrationPartTwoAlternative() {
    this.props.form.validateFields(
      [
        'user.placeOfResidenceAlternative',
        'user.street',
        'user.placeZipAlternative',
        'user.telephone',
        'user.processingLoginData',
        'user.agb',
        'user.processingAdvertisementData',
      ],
      {},
      (error, value) => {
        if (error == null && value.user.processingLoginData === true && value.user.agb === true) {
          delete value.user.placeZip
          delete value.user.placeOfResidence
          let correctedPlaceOfResidence = this.renameProp('placeOfResidenceAlternative', 'placeOfResidence', value.user)
          let newUserData = this.renameProp('placeZipAlternative', 'placeZip', correctedPlaceOfResidence)
          User = { ...User, ...newUserData }
          this.registerUser()
        } else {
          errorLog({
            error: error,
            info:
              " can't submit Registration Form 2 (Alternative Form for Users who do not live in SouthTyrol) in LoginForm",
            custom: true,
          })
        }
      },
    )
  }
  render() {
    const {
      form,
      callBackAfterLogin,
      callBackAfterRegistration,
      callBackAfterLogout,
      processingLoginDataLink,
      agbLink,
      netiquetteLink,
      processingAdvertisementDataLink,
      ...props
    } = this.props
    const { usernameFromLoginForm, passwordFromLoginForm, currentTitle, screen, request } = this.state
    const { getFieldProps, getFieldError } = form
    const ErrorMessage = ({ field, ...props }) => {
      const errors = getFieldError(field)
      if (errors) return <IconError errorMessage={errors.join(',')} {...props} />
      return null
    }
    //label setting for registration part two
    let labelProcessingLoginData = (
      <span>
        {translate('login_checkbox_processingLoginData_label_beforeLink') + ' '}
        <LabelLink target="_blank" href={processingLoginDataLink}>
          {translate('login_checkbox_processingLoginData_label_link') + ' '}
        </LabelLink>
        {translate('login_checkbox_processingLoginData_label_afterLink')}
      </span>
    )
    let labelProcessingAdvertisementData = (
      <span>
        {translate('login_checkbox_processingAdvertisementData_label_beforeLink') + ' '}
        <LabelLink target="_blank" href={processingAdvertisementDataLink}>
          {translate('login_checkbox_processingAdvertisementData_label_link') + ' '}
        </LabelLink>
        {translate('login_checkbox_processingAdvertisementData_label_afterLink')}
      </span>
    )
    let labelAGB = (
      <span>
        {translate('login_checkbox_agb_label_beforeAGBLink') + ' '}
        <LabelLink target="_blank" href={agbLink}>
          {translate('login_checkbox_agb_label_AGBLink') + ' '}
        </LabelLink>
        {translate('login_checkbox_agb_label_afterAGBLink') + ' '}
        <LabelLink href={netiquetteLink}>{translate('login_checkbox_agb_label_NetiquetteLink') + ' '}</LabelLink>
        {translate('login_checkbox_agb_label_afterNetiquetteLink')}
      </span>
    )
    //declaration of input fields
    const loginFields = [
      {
        type: 'email',
        icon: 'email',
        errorMessage: translate('login_username_errorMessage'),
        placeholder: translate('login_username_placeholder'),
        name: 'user.username',
        required: true,
        errorMessageEnabled: true,
        onKeyPressSubmit: true,
        onKeyPressFunction: this.submitLogin,
        validationType: 'email',
      },
      {
        type: 'password',
        icon: 'key',
        errorMessage: translate('login_password_errorMessage'),
        placeholder: translate('login_password_placeholder'),
        name: 'user.password',
        required: true,
        errorMessageEnabled: true,
        onKeyPressSubmit: true,
        onKeyPressFunction: this.submitLogin,
      },
    ]
    const registerFields = [
      {
        type: 'email',
        icon: 'email',
        errorMessage: translate('login_username_errorMessage'),
        placeholder: User.email !== undefined ? User.email : translate('login_username_placeholder'),
        value: User.email !== undefined ? User.email : '',
        name: 'user.username',
        required: User.email !== undefined ? false : true,
        errorMessageEnabled: User.email !== undefined ? false : true,
      },
      {
        type: 'password',
        icon: 'key',
        errorMessage: translate('login_password_errorMessage'),
        placeholder: User.password !== undefined ? User.password : translate('login_password_placeholder'),
        name: 'user.password',
        value: User.password !== undefined ? User.password : '',
        required: User.password !== undefined ? false : true,
        errorMessageEnabled: User.password !== undefined ? false : true,
      },
      {
        type: 'select',
        values: genderOptions,
        errorMessage: translate('login_select_gender_errorMessage'),
        placeholder:
          User.gender !== undefined
            ? User.gender === 'man' && genderOptions[0].label
            : User.gender === 'woman'
            ? genderOptions[1].label
            : translate('login_select_gender_placeholder'),
        value: User.gender ? (User.gender === 'man' ? genderOptions[0] : genderOptions[1]) : undefined,
        name: 'user.gender',
        required: true,
        errorMessageEnabled: User.gender !== undefined ? false : true,
        initialValue: User.gender ? User.gender : undefined,
      },
      {
        errorMessage: translate('login_firstName_errorMessage'),
        placeholder: User.firstName !== undefined ? User.firstName : translate('login_firstName'),
        value: User.firstName !== undefined ? User.firstName : '',
        name: 'user.firstName',
        required: User.firstName !== undefined ? false : true,
        errorMessageEnabled: User.firstName !== undefined ? false : true,
      },
      {
        errorMessage: translate('login_lastName_errorMessage'),
        placeholder: User.lastName !== undefined ? User.lastName : translate('login_lastName'),
        value: User.lastName !== undefined ? User.lastName : '',
        name: 'user.lastName',
        required: User.lastName !== undefined ? false : true,
        errorMessageEnabled: User.lastName !== undefined ? false : true,
        onKeyPressSubmit: true,
        onKeyPressFunction: this.submitRegistration,
      },
      {
        type: 'image',
        name: 'user.image',
        required: false,
        errorMessage: translate('ugc_input_dropzone_images_error'),
        value: JSON.parse(getStoredItem('user')) !== null ? JSON.parse(getStoredItem('user')).image : undefined,
        dropZoneInfo: translate('input_dropzone_profile_image_info'),
      },
    ]
    const registerPartTwoFields = [
      {
        type: 'select',
        values: placeOfResidenceOptions,
        showNoOption: true,
        errorMessage: translate('login_select_placeOfResidence_errorMessage'),
        placeholder:
          User.placeOfResidence !== undefined
            ? User.placeOfResidence
            : translate('login_select_placeOfResidence_placeholder'),
        name: 'user.placeOfResidence',
        onChange: this.getZipFromPreselectedCommunity,
        required: true,
        errorMessageEnabled: true,
      },
      {
        errorMessage: translate('login_street_errorMessage'),
        placeholder: User.street !== undefined ? User.street : translate('login_street_placeholder'),
        name: 'user.street',
        required: true,
        errorMessageEnabled: true,
      },
      {
        type: 'select',
        values: zipOptions,
        errorMessage: translate('login_select_zip_errorMessage'),
        placeholder:
          User.placeZip !== undefined && User.placeZip !== null
            ? User.placeZip.label
            : translate('login_select_zip_placeholder'),
        value: User.placeZip !== undefined && User.placeZip,
        name: 'user.placeZip',
        required: true,
        errorMessageEnabled: true,
      },
      {
        type: 'tel',
        errorMessage: translate('login_telephone_errorMessage'),
        placeholder: User.telephone !== undefined ? User.telephone : translate('login_telephone_placeholder'),
        name: 'user.telephone',
        required: true,
        errorMessageEnabled: true,
        onKeyPressSubmit: true,
        onKeyPressFunction: this.submitRegistrationPartTwo,
      },
      {
        type: 'checkbox',
        errorMessage: translate('login_checkbox_processingLoginData_errorMessage'),
        label: labelProcessingLoginData,
        name: 'user.processingLoginData',
        value: true,
        required: true,
      },
      {
        type: 'checkbox',
        errorMessage: translate('login_checkbox_agb_errorMessage'),
        label: labelAGB,
        name: 'user.agb',
        value: true,
        required: true,
      },
      {
        type: 'checkbox',
        errorMessage: translate('login_checkbox_processingAdvertisementData_errorMessage'),
        label: labelProcessingAdvertisementData,
        name: 'user.processingAdvertisementData',
        value: false,
        required: false,
      },
    ]
    const registerPartTwoFieldsAlternative = [
      {
        errorMessage: translate('login_select_placeOfResidence_errorMessage'),
        placeholder:
          User.placeOfResidence !== undefined
            ? User.placeOfResidence
            : translate('login_select_placeOfResidence_placeholder'),
        name: 'user.placeOfResidenceAlternative',
        required: true,
        errorMessageEnabled: true,
      },
      {
        errorMessage: translate('login_street_errorMessage'),
        placeholder: User.street !== undefined ? User.street : translate('login_street_placeholder'),
        name: 'user.street',
        required: true,
        errorMessageEnabled: true,
      },
      {
        errorMessage: translate('login_select_zip_errorMessage'),
        placeholder:
          User.placeZip !== undefined && User.placeZip !== null
            ? User.placeZip.label
            : translate('login_select_zip_placeholder'),
        name: 'user.placeZipAlternative',
        required: true,
        errorMessageEnabled: true,
      },
      {
        type: 'tel',
        errorMessage: translate('login_telephone_errorMessage'),
        placeholder: User.telephone !== undefined ? User.telephone : translate('login_telephone_placeholder'),
        name: 'user.telephone',
        required: true,
        errorMessageEnabled: true,
        onKeyPressSubmit: true,
        onKeyPressFunction: this.submitRegistrationPartTwoAlternative,
      },
      {
        type: 'checkbox',
        errorMessage: translate('login_checkbox_processingLoginData_errorMessage'),
        label: labelProcessingLoginData,
        name: 'user.processingLoginData',
        value: true,
        required: true,
      },
      {
        type: 'checkbox',
        errorMessage: translate('login_checkbox_agb_errorMessage'),
        label: labelAGB,
        name: 'user.agb',
        value: true,
        required: true,
      },
      {
        type: 'checkbox',
        errorMessage: translate('login_checkbox_processingAdvertisementData_errorMessage'),
        label: labelProcessingAdvertisementData,
        name: 'user.processingAdvertisementData',
        value: false,
        required: false,
      },
    ]
    const passwordForgottenFields = [
      {
        type: 'email',
        icon: 'email',
        errorMessage: translate('login_username_errorMessage'),
        placeholder: translate('login_username_placeholder'),
        name: 'user.username',
        required: true,
        errorMessageEnabled: true,
        onKeyPressSubmit: true,
        onKeyPressFunction: this.submitPasswordForgottenRequest,
      },
    ]
    const passwordResetRequestFields = [
      {
        type: 'email',
        icon: 'email',
        errorMessage: translate('login_username_errorMessage'),
        placeholder: translate('login_username_placeholder'),
        name: 'user.username',
        required: true,
        errorMessageEnabled: true,
      },
      {
        type: 'password',
        icon: 'key',
        errorMessage: translate('login_username_errorMessage'),
        placeholder: translate('login_password_placeholder'),
        name: 'user.password',
        required: true,
        errorMessageEnabled: true,
      },
      {
        type: 'password',
        icon: 'key',
        errorMessage: translate('login_username_errorMessage'),
        placeholder: translate('login_password_check_placeholder'),
        name: 'user.passwordCheck',
        required: true,
        errorMessageEnabled: true,
        onKeyPressSubmit: true,
        onKeyPressFunction: this.submitPasswordResetRequest,
      },
    ]
    let usersDataFields = [
      {
        type: 'image',
        name: 'user.image',
        required: false,
        errorMessage: translate('ugc_input_dropzone_images_error'),
        value: JSON.parse(getStoredItem('user')) !== null ? JSON.parse(getStoredItem('user')).image : undefined,
        errorMessageEnabled: false,
        dropZoneInfo: translate('input_dropzone_new_profile_image_info'),
      },
      {
        type: 'email',
        icon: 'email',
        disabled: true,
        errorMessage: translate('login_username_errorMessage'),
        placeholder: translate('login_username_placeholder'),
        value: JSON.parse(getStoredItem('user')) !== null ? JSON.parse(getStoredItem('user')).email : '',
        name: 'user.username',
        required: false,
        errorMessageEnabled: false,
      },
      {
        type: 'select',
        values: genderOptions,
        errorMessage: translate('login_select_gender_errorMessage'),
        placeholder: translate('login_select_gender_placeholder'),
        value:
          JSON.parse(getStoredItem('user')) === null
            ? translate('login_select_gender_placeholder')
            : JSON.parse(getStoredItem('user')).gender === 'man'
            ? genderOptions[0]
            : genderOptions[1],
        name: 'user.gender',
        required: false,
        errorMessageEnabled: false,
      },
      {
        type: 'text',
        disabled: true,
        errorMessage: translate('login_firstName_errorMessage'),
        placeholder: translate('login_firstName'),
        value: JSON.parse(getStoredItem('user')) !== null ? JSON.parse(getStoredItem('user')).firstName : '',
        name: 'user.firstName',
        required: false,
        errorMessageEnabled: false,
      },
      {
        type: 'text',
        disabled: true,
        errorMessage: translate('login_lastName_errorMessage'),
        placeholder: translate('login_lastName'),
        value: JSON.parse(getStoredItem('user')) !== null ? JSON.parse(getStoredItem('user')).lastName : '',
        name: 'user.lastName',
        required: false,
        errorMessageEnabled: false,
      },
      {
        type: 'text',
        errorMessage: translate('login_select_placeOfResidence_errorMessage'),
        placeholder: translate('login_select_placeOfResidence_placeholder'),
        name: 'user.placeOfResidence',
        value: JSON.parse(getStoredItem('user')) !== null ? JSON.parse(getStoredItem('user')).placeOfResidence : '',
        required: false,
        errorMessageEnabled: false,
      },
      {
        type: 'text',
        errorMessage: translate('login_street_errorMessage'),
        placeholder: translate('login_street_placeholder'),
        name: 'user.street',
        value: JSON.parse(getStoredItem('user')) !== null ? JSON.parse(getStoredItem('user')).street : '',
        required: false,
        errorMessageEnabled: false,
      },
      {
        type: 'text',
        errorMessage: translate('login_select_zip_errorMessage'),
        placeholder: translate('login_select_zip_placeholder'),
        name: 'user.placeZip',
        value: JSON.parse(getStoredItem('user')) !== null ? JSON.parse(getStoredItem('user')).placeZip : '',
        errorMessageEnabled: false,
        required: false,
      },
      {
        type: 'tel',
        errorMessage: translate('login_telephone_errorMessage'),
        placeholder: translate('login_telephone_placeholder'),
        value: JSON.parse(getStoredItem('user')) !== null ? JSON.parse(getStoredItem('user')).telephone : '',
        name: 'user.telephone',
        errorMessageEnabled: false,
        required: false,
        onKeyPressSubmit: true,
        onKeyPressFunction: this.submitChangeDataRequest,
      },
      {
        type: 'checkbox',
        errorMessage: translate('login_checkbox_processingAdvertisementData_errorMessage'),
        label: labelProcessingAdvertisementData,
        name: 'user.processingAdvertisementData',
        value:
          JSON.parse(getStoredItem('user')) !== null &&
          JSON.parse(getStoredItem('user')).processingAdvertisementData === 1
            ? true
            : false,
        required: false,
      },
    ]
    //set input fields, title, buttons, hints
    let fields = loginFields
    if (
      (getStoredItem('user') !== null && getStoredItem('access_token', true) !== null) ||
      (this.props._match.path === namedRoute('account').path && JSON.parse(getStoredItem('user')) !== null)
    ) {
      if (this.state.currentTitle.props.children !== translate('login_change_my_data')) {
        this.setState({
          screen: 'account',
          currentTitle: <StyledTitle tag="h4">{translate('login_change_my_data')}</StyledTitle>,
        })
      }
      fields = usersDataFields
      if (!isServerSide()) {
        window.top.history.pushState('', 'account', namedRoute('account').path)
      }
    } else if (screen === 'register.verification_2_alternative') {
      if (currentTitle.props.children !== translate('login_title_register_part_two')) {
        this.setState({
          currentTitle: <StyledTitle tag="h4">{translate('login_title_register_part_two')}</StyledTitle>,
          screen: 'register.verification_2_alternative',
        })
      }
      fields = registerPartTwoFieldsAlternative
    } else if (screen === 'register.verification_2') {
      if (currentTitle.props.children !== translate('login_title_register_part_two')) {
        this.setState({
          currentTitle: <StyledTitle tag="h4">{translate('login_title_register_part_two')}</StyledTitle>,
          screen: 'register.verification_2',
        })
      }
      fields = registerPartTwoFields
    } else if (screen === 'register.verification') {
      if (currentTitle.props.children !== translate('login_title_register')) {
        this.setState({
          currentTitle: <StyledTitle tag="h4">{translate('login_title_register')}</StyledTitle>,
          screen: 'register.verification',
        })
      }
      fields = registerFields
    } else if (screen === 'resetPassword') {
      if (currentTitle.props.children !== translate('login_reset_password_title')) {
        this.setState({
          currentTitle: <StyledTitle tag="h4">{translate('login_reset_password_title')}</StyledTitle>,
          screen: 'resetPassword',
        })
      }
      fields = passwordForgottenFields
    } else if (screen === 'resetPassword_2') {
      if (currentTitle.props.children !== translate('login_reset_password_part_two_title')) {
        this.setState({
          currentTitle: <StyledTitle tag="h4">{translate('login_reset_password_part_two_title')}</StyledTitle>,
          screen: 'resetPassword_2',
        })
      }
      if (!isServerSide()) {
        window.top.history.pushState('', 'account', namedRoute('account').path)
      }
      fields = passwordResetRequestFields
    } else if (
      screen === 'login' ||
      namedRoute('login').path === this.props._match.path ||
      (this.props._match.path === namedRoute('account').path && JSON.parse(getStoredItem('user')) === null)
    ) {
      if (currentTitle.props.children !== translate('login_title')) {
        this.setState({
          currentTitle: <StyledTitle tag="h4">{translate('login_title')}</StyledTitle>,
          screen: 'login',
        })
      }
      if (!isServerSide()) {
        if (namedRoute('login').path !== this.props._match.path) {
          window.top.history.pushState('', 'login', namedRoute('login').path)
        }
      }
      fields = loginFields
    }

    //axios instance for registering a user
    let axiosInstance = axios.create({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    //
    //axios instance for resetting a password
    let resetPasswordAxiosInstance = axios.create({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    //
    let access = getStoredItem('access_token', true) !== null && getStoredItem('access_token', true)
    //axios instance for updating user
    let userHasSentChangeDataAxiosInstance = axios.create({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + access,
      },
    })
    return (
      <LoginWrapper {...props}>
        {
          //Title
          currentTitle
        }
        {
          //optional Message
          this.state.loginMessage && JSON.parse(getStoredItem('user')) === null && (
            <LoginMessage>{this.state.loginMessage}</LoginMessage>
          )
        }
        {
          //fields
          fields.map((field) => {
            switch (field.type) {
              case 'select':
                return (
                  <SelectWrapper key={field.placeholder}>
                    <Select
                      values={field.values}
                      myOnChange={field.onChange}
                      placeholder={field.placeholder && field.placeholder}
                      {...getFieldProps(field.name, {
                        rules: [{ required: field.required, message: field.errorMessage }],
                        initialValue: field.value,
                      })}
                    />
                    {field.errorMessageEnabled && getFieldError(field.name) && (
                      <SelectIconError errorMessage={field.errorMessage} />
                    )}
                    {field.showNoOption && (
                      <StyledHelpButton
                        onClick={() => {
                          this.setState({
                            screen: 'register.verification_2_alternative',
                          })
                        }}
                      >
                        {translate('outside_southtyrol')}
                      </StyledHelpButton>
                    )}
                  </SelectWrapper>
                )
              case 'checkbox':
                return (
                  <CheckBoxWrapper>
                    <StyledCheckBox
                      key={field.label}
                      label={field.label}
                      {...getFieldProps(field.name, {
                        rules: [{ required: field.required, message: field.errorMessage }],
                        initialValue: field.value,
                        valuePropName: 'checked',
                      })}
                    />
                    {getFieldError(field.name) && <SelectIconError errorMessage={field.errorMessage} />}
                  </CheckBoxWrapper>
                )
              case 'image': {
                if (field.value && field.value.length > 0) {
                  return (
                    <UserEditor>
                      {this.state.deleteUserImage === false && (
                        <UserImageWrapper
                          onClick={() => {
                            if (field.value !== '/images/default_avatar.svg') {
                              this.setState({ deleteUserImage: true })
                            }
                          }}
                        >
                          {field.value !== '/images/default_avatar.svg' && (
                            <DeleteLayer className="deleteLayer">
                              <DeleteIcon icon="bin" />
                            </DeleteLayer>
                          )}
                          <UserImage src={field.value} />
                        </UserImageWrapper>
                      )}
                      <StyledInputDropZone
                        form={form}
                        maxFiles={1}
                        showFileInfoPreview={false}
                        showFileInputPreview={false}
                        hideDropZoneAfterUpload
                        profilePicture
                        dropZoneInfo={field.dropZoneInfo}
                        {...getFieldProps(field.name, {
                          trigger: 'onDropChange',
                          rules: [
                            {
                              required: field.required,
                              message: field.errorMessage,
                            },
                          ],
                        })}
                      />
                    </UserEditor>
                  )
                } else {
                  return (
                    <StyledInputDropZoneWrapper>
                      <StyledInputDropZone
                        form={form}
                        maxFiles={1}
                        showFileInfoPreview={false}
                        showFileInputPreview={false}
                        hideDropZoneAfterUpload
                        profilePicture
                        dropZoneInfo={translate('input_dropzone_profile_image_info')}
                        {...getFieldProps(field.name, {
                          trigger: 'onDropChange',
                          rules: [
                            {
                              required: field.required,
                              message: field.errorMessage,
                            },
                          ],
                        })}
                      />
                    </StyledInputDropZoneWrapper>
                  )
                }
              }
              default:
                const fieldRules = { required: field.required, message: field.errorMessage }
                if (field.validationType) {
                  fieldRules.type = field.validationType
                }
                const validationFieldProps = getFieldProps(field.name, { rules: [fieldRules] })
                return (
                  <Fragment>
                    <StyledInput
                      key={field.placeholder}
                      customValue={field.value}
                      autofill={false}
                      prepend={field.icon && <StyledPrependIcon icon={field.icon} />}
                      append={
                        field.errorMessageEnabled && field.type !== 'password' ? (
                          <ErrorMessage field={field.name} />
                        ) : (
                          field.errorMessageEnabled &&
                          field.type === 'password' && (
                            <div>
                              <PasswordEye
                                onClick={(visiblity) => {
                                  this.setState({ passwordIsVisible: visiblity })
                                }}
                              />
                              <ErrorMessage field={field.name} />
                            </div>
                          )
                        )
                      }
                      disabled={field.disabled}
                      placeholder={field.placeholder && field.placeholder}
                      type={field.type !== 'password' ? field.type : this.state.passwordIsVisible ? 'text' : 'password'}
                      onKeyPress={(event) => {
                        if (event.key === 'Enter') {
                          let keyPressFunction = field.onKeyPressFunction
                          field.onKeyPressSubmit && keyPressFunction()
                        }
                      }}
                      {...validationFieldProps}
                    />
                  </Fragment>
                )
            }
          })
        }
        {
          //Buttons
        }
        <ButtonWrapper>
          {
            // Login Button
            screen === 'login' && JSON.parse(getStoredItem('user')) === null && (
              <StyledButton onClick={this.submitLogin}>{translate('login')}</StyledButton>
            )
          }
          {
            // Register Button - to create a new Account
            screen === 'login' && JSON.parse(getStoredItem('user')) === null && (
              <StyledButton
                onClick={() => {
                  if (!isServerSide()) {
                    window.top.history.pushState('', 'account', generatePathByRouteName('register.verification', '/'))
                  }
                  this.setState({
                    screen: 'register.verification',
                  })
                }}
              >
                {translate('login_register')}
              </StyledButton>
            )
          }
          {
            // Register Button - to insert information in part two
            screen === 'register.verification' && getStoredItem('user') === null && (
              <StyledButton onClick={this.submitRegistration}>{translate('login_register_next')}</StyledButton>
            )
          }
          {
            // Register Button - to Register the User
            screen === 'register.verification_2' && (
              <StyledButton onClick={this.submitRegistrationPartTwo}>{translate('login_register')}</StyledButton>
            )
          }
          {
            // Register Button - to Register the User
            screen === 'register.verification_2_alternative' && (
              <StyledButton onClick={this.submitRegistrationPartTwoAlternative}>
                {translate('login_register')}
              </StyledButton>
            )
          }
          {
            // Button in the reset Password - Form 2
            screen === 'resetPassword_2' && getStoredItem('user') === null && (
              <StyledButton onClick={this.submitPasswordResetRequest}>{translate('login_reset_password')}</StyledButton>
            )
          }
          {
            // Button in the reset Password - Form part 1
            screen === 'resetPassword' && getStoredItem('user') === null && (
              <StyledButton onClick={this.submitPasswordForgottenRequest}>
                {translate('login_reset_password')}
              </StyledButton>
            )
          }
          {
            // Change Data Button
            JSON.parse(getStoredItem('user')) !== null && (
              <StyledButton onClick={this.submitChangeDataRequest}>{translate('save')}</StyledButton>
            )
          }
          {
            // Logout Button
            JSON.parse(getStoredItem('user')) !== null && (
              <StyledButton
                onClick={() => {
                  User = {}
                  if (!isServerSide()) {
                    window.top.history.pushState('', 'login', namedRoute('login').path)
                  }
                  this.setState({
                    usernameFromLoginForm: '',
                    passwordFromLoginForm: '',
                    screen: 'login',
                    request: 'login_logout',
                  })
                  clearStoredItem('user')
                  clearStoredItem('access_token', true)
                  clearStoredItem('access_token_expires_in', true)
                  clearStoredItem('refresh_token', true)
                  callBackAfterLogout()
                }}
              >
                {translate('logout')}
              </StyledButton>
            )
          }
        </ButtonWrapper>
        <Help>
          {
            // Loginform - Passwort vergessen?
            screen === 'login' && getStoredItem('user') === null && getStoredItem('access_token', true) === null && (
              <StyledText
                onClick={() => {
                  if (!isServerSide()) {
                    window.top.history.pushState(
                      '',
                      generatePathByRouteName('resetPassword', ''),
                      generatePathByRouteName('resetPassword', ''),
                    )
                  }
                  this.setState({
                    screen: 'resetPassword',
                  })
                }}
              >
                {translate('login_password_forgotten')} ?
              </StyledText>
            )
          }
          {
            // Text to enable User to login with other email(username) - first part of Registration
            screen === 'register.verification' && getStoredItem('user') === null && (
              <StyledText
                onClick={() => {
                  User = {}
                  if (!isServerSide()) {
                    window.top.history.pushState('', 'login', namedRoute('login').path)
                  }
                  this.setState({
                    screen: 'login',
                    request: '',
                  })
                }}
              >
                {translate('login_with_other_username')}
              </StyledText>
            )
          }
          {
            // Text which enables User to go back to part one of the Registration form
            screen === 'register.verification_2' && (
              <StyledText
                onClick={() => {
                  delete User.image
                  this.setState({
                    screen: 'register.verification',
                    request: '',
                  })
                }}
              >
                {translate('login_back')}
              </StyledText>
            )
          }
          {
            // Text which enables User to go back to part one of the Registration form
            screen === 'register.verification_2_alternative' && (
              <StyledText
                onClick={() => {
                  this.setState({
                    screen: 'register.verification_2',
                    request: '',
                  })
                }}
              >
                {translate('login_back')}
              </StyledText>
            )
          }
          {
            // Text which enables User to go back to the login
            screen === 'register.verification_2' && (
              <StyledText
                onClick={() => {
                  User = {}
                  if (!isServerSide()) {
                    window.top.history.pushState('', 'login', namedRoute('login').path)
                  }
                  this.setState({
                    screen: 'login',
                    request: '',
                  })
                }}
              >
                {translate('back_to_login')}
              </StyledText>
            )
          }
          {
            // Text which enables User to go back to the login
            screen === 'register.verification_2_alternative' && (
              <StyledText
                onClick={() => {
                  User = {}
                  if (!isServerSide()) {
                    window.top.history.pushState('', 'login', namedRoute('login').path)
                  }
                  this.setState({
                    screen: 'login',
                    request: '',
                  })
                }}
              >
                {translate('back_to_login')}
              </StyledText>
            )
          }
          {
            // Text which enables User to go to the reset password form
            screen === 'resetPassword' && getStoredItem('user') === null && (
              <StyledText
                onClick={() =>
                  this.setState({
                    screen: 'login',
                  })
                }
              >
                {translate('login_back')}
              </StyledText>
            )
          }
          {
            //REQUESTS
          }
          {
            // User change data
            request === 'account' && JSON.parse(getStoredItem('user')) !== null && (
              <AxiosProvider instance={userHasSentChangeDataAxiosInstance}>
                <Post url={Config.restUrl('user')} data={User}>
                  {(error, response, isLoading) => {
                    if (response && response.status === 200) {
                      if (response.data.success) {
                        setStoredItem('user', JSON.stringify(response.data.data))
                        return <StyledConfirmationText>{translate('data_succesfully_changed')}</StyledConfirmationText>
                      }
                    }
                    if (isLoading) {
                      return <StyledCircularProgress />
                    }
                    if (error) {
                      errorLog({ error: error, info: 'User change data request failed' })
                      if (!isServerSide()) {
                        window.setTimeout(() => {
                          this.setState({
                            request: '',
                          })
                        }, 10000)
                      }
                      if (error.response && error.response.data && error.response.data.validation) {
                        return Object.keys(error.response.data.validation).map((key) => (
                          <StyledErrorText key={key + 'error'}>
                            {error.response.data.validation[key][0]}
                          </StyledErrorText>
                        ))
                      } else {
                        return <StyledErrorText>{translate('login_change_data_error')}</StyledErrorText>
                      }
                    } else {
                      return <Fragment></Fragment>
                    }
                  }}
                </Post>
              </AxiosProvider>
            )
          }
          {
            // Password reset to receive token
            request === 'resetPassword' && (
              <AxiosProvider instance={resetPasswordAxiosInstance}>
                <Post url={Config.restUrl('login/password-reset')} data={'email=' + usernameFromLoginForm}>
                  {(error, response, isLoading) => {
                    if (response && response.status === 200) {
                      if (response.data.success) {
                        return (
                          <StyledConfirmationText>
                            <div dangerouslySetInnerHTML={this.createMarkup(response.data.message)} />
                          </StyledConfirmationText>
                        )
                      }
                    }
                    if (isLoading) {
                      return <StyledCircularProgress />
                    }
                    if (error) {
                      if (error.response && error.response.data && error.response.data.validation) {
                        return Object.keys(error.response.data.validation).map((key) => (
                          <StyledErrorText key={key + 'error'}>
                            {error.response.data.validation[key][0]}
                          </StyledErrorText>
                        ))
                      } else {
                        return <StyledErrorText>{translate('login_password_reset_error')}</StyledErrorText>
                      }
                    } else {
                      errorLog({ error: error, info: 'Password reset to receive token request failed' })
                      return <Fragment></Fragment>
                    }
                  }}
                </Post>
              </AxiosProvider>
            )
          }
          {
            //password reset request
            request === 'resetPassword_2' && (
              <AxiosProvider instance={resetPasswordAxiosInstance}>
                <Put
                  url={Config.restUrl('login/password-reset')}
                  data={
                    'email=' +
                    usernameFromLoginForm +
                    '&token=' +
                    this.props._match.params.resetToken +
                    '&password=' +
                    passwordFromLoginForm
                  }
                >
                  {(error, response, isLoading) => {
                    if (response && response.status === 200) {
                      if (response.data.success) {
                        if (!isServerSide()) {
                          window.setTimeout(() => {
                            this.setState({
                              usernameFromLoginForm: '',
                              passwordFromLoginForm: '',
                              screen: 'login',
                              request: '',
                            })
                          }, 7000)
                        }
                        return (
                          <StyledConfirmationText>
                            <div dangerouslySetInnerHTML={this.createMarkup(response.data.message)} />
                          </StyledConfirmationText>
                        )
                      } else {
                        return (
                          <StyledErrorText>
                            <div dangerouslySetInnerHTML={this.createMarkup(response.data.message)} />
                          </StyledErrorText>
                        )
                      }
                    }
                    if (isLoading) {
                      return <StyledCircularProgress />
                    }
                    if (error) {
                      errorLog({
                        error: error,
                        info:
                          'Setting new Password failed with token' +
                          this.props._match.params.resetToken +
                          'User: ' +
                          usernameFromLoginForm,
                      })
                      window.setTimeout(() => {
                        this.setState({
                          usernameFromLoginForm: '',
                          passwordFromLoginForm: '',
                          screen: 'login',
                          request: '',
                        })
                      }, 7000)
                      if (error.response && error.response.data && error.response.data.validation) {
                        return Object.keys(error.response.data.validation).map((key) => (
                          <StyledErrorText key={key + 'error'}>
                            {error.response.data.validation[key][0]}
                          </StyledErrorText>
                        ))
                      } else {
                        return <StyledErrorText>{translate('login_password_reset_error')}</StyledErrorText>
                      }
                    } else {
                      return <Fragment />
                    }
                  }}
                </Put>
              </AxiosProvider>
            )
          }
          {
            // Registration request
            request === 'register.verification' && (
              <AxiosProvider instance={axiosInstance}>
                <Put url={Config.restUrl('register')} data={User}>
                  {(error, response, isLoading) => {
                    if (response && response.status === 200) {
                      User = {}
                      return (
                        <StyledConfirmationText>
                          <div dangerouslySetInnerHTML={this.createMarkup(response.data.message)} />
                        </StyledConfirmationText>
                      )
                    } else if (isLoading) {
                      return <StyledCircularProgress />
                    } else if (error) {
                      errorLog({ error: error, info: 'Registration request failed for User: ' + JSON.stringify(User) })
                      if (error.response && error.response.data && error.response.data.validation) {
                        return Object.keys(error.response.data.validation).map((key) => (
                          <StyledErrorText key={key + 'error'}>
                            {error.response.data.validation[key][0]}
                          </StyledErrorText>
                        ))
                      } else {
                        return <Fragment />
                      }
                    } else {
                      return <Fragment />
                    }
                  }}
                </Put>
              </AxiosProvider>
            )
          }
          {
            // Login request
            request === 'login' && (
              <Login
                callBackAfterLogin={this.callBackAfterLogin}
                username={usernameFromLoginForm}
                password={passwordFromLoginForm}
                showError={screen === 'login'}
              />
            )
          }
        </Help>
      </LoginWrapper>
    )
  }
}

LoginForm.defaultProps = {
  callBackAfterLogin: () => {},
  callBackAfterLogout: () => {},
  callBackAfterRegistration: () => {},
  processingLoginDataLink: 'https://www.iubenda.com/privacy-policy/88316793',
  agbLink: '/agb',
  netiquetteLink: '/agb',
  processingAdvertisementDataLink: 'https://www.iubenda.com/privacy-policy/88316793',
}

export default withRouter(createForm()(LoginForm))
export {
  StyledCheckBox as StyledCheckBox0LoginForm,
  StyledInput as StyledInput0LoginForm,
  SelectWrapper as SelectWrapper0LoginForm,
  StyledText as StyledText0LoginForm,
  StyledErrorText as StyledErrorText0LoginForm,
  StyledConfirmationText as StyledConfirmationText0LoginForm,
  StyledCircularProgress as StyledCircularProgress0LoginForm,
  StyledTitle as StyledTitle0LoginForm,
  StyledInputDropZone as StyledInputDropZone0LoginForm,
  StyledHelpButton as StyledHelpButton0LoginForm,
}
